<template>
    <div class="email-recipient-input">
        <div class="recipient-tags">
            <span v-for="(recipient, index) in recipients" :key="index" class="recipient-tag">
                {{ recipient }}
                <span class="remove-tag" @click="removeRecipient(index)">&times;</span>
            </span>
        </div>
        <input type="text" v-model="inputValue" @keydown.enter.prevent="addRecipient" @keydown.delete="handleDelete"
            @blur="validateAndAdd" :placeholder="recipients.length ? '' : placeholder" class="recipient-input" />
    </div>
</template>

<script>
export default {
    name: 'WidgetEmailRecipientInput',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: 'Enter email addresses...'
        },
        maxRecipients: {
            type: Number,
            default: 50
        }
    },
    data() {
        return {
            recipients: [],
            inputValue: ''
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.recipients = [...newVal]
            },
            immediate: true
        }
    },
    methods: {
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        addRecipient() {
            const email = this.inputValue.trim().toLowerCase()
            if (!email) return

            if (this.recipients.includes(email)) {
                this.$emit('duplicate', email)
                this.inputValue = ''
                return
            }

            if (this.validateEmail(email)) {
                if (this.recipients.length < this.maxRecipients) {
                    this.recipients.push(email)
                    this.$emit('input', this.recipients)
                    this.$emit('add', email)
                    this.inputValue = ''
                } else {
                    this.$emit('max-reached')
                }
            } else {
                this.$emit('invalid', email)
            }
        },
        removeRecipient(index) {
            const removed = this.recipients.splice(index, 1)[0]
            this.$emit('input', this.recipients)
            this.$emit('remove', removed)
        },
        handleDelete(e) {
            if (!this.inputValue && this.recipients.length) {
                e.preventDefault()
                this.removeRecipient(this.recipients.length - 1)
            }
        },
        validateAndAdd() {
            if (this.inputValue) {
                this.addRecipient()
            }
        }
    }
}
</script>

<style scoped>
.email-recipient-input {
    border: 1px solid #ddd;
    padding: 5px;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 35px;
}

.recipient-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.recipient-tag {
    background-color: #e9ecef;
    border-radius: 3px;
    padding: 2px 8px;
    margin: 2px;
    display: inline-flex;
    align-items: center;
}

.remove-tag {
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
}

.recipient-input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 120px;
    padding: 4px;
}

.recipient-input::placeholder {
    color: #999;
}
</style>